import { PickerItem } from '../types'

export type MenuRow<Item extends PickerItem> =
  | { kind: 'group'; title: string }
  | { kind: 'item'; item: Item; groupTitle?: string }

export const toMenuRows = <Item extends PickerItem>(items: Item[]): MenuRow<Item>[] =>
  items.map((item): MenuRow<Item> => ({ kind: 'item', item }))

export const getGroupedMenuRows = <Item extends PickerItem>(items: Item[]): MenuRow<Item>[] => {
  const itemsByGroup: Record<string, Item[]> = {}

  items.forEach(item => {
    const groupTitle = `${item.groupBy}`
    itemsByGroup[groupTitle] = [...(itemsByGroup[groupTitle] ?? []), item]
  })

  return Object.entries(itemsByGroup).flatMap(([title, groupItems]): MenuRow<Item>[] => [
    { kind: 'group', title },
    ...groupItems.map((item): MenuRow<Item> => ({ kind: 'item', item, groupTitle: title })),
  ])
}
